import React, { useEffect } from 'react';
// @ts-ignore
import * as powerbi from './plugin/powerbi.min.js';
import { getPowerBIInfo } from '@/pages/dashboard/services/dashboard';

export default () => {
  const reportId = '75893725-bd9b-447f-a107-c7325ebc24a4';

  const getReportIndo = () => {
    getPowerBIInfo(reportId).then(data => {
      const { url, token } = data;
      const $container = document.getElementById('powerbi-container');
      const reportLoadConfig = {
        type: "report",
        id: reportId,
        tokenType: powerbi.models.TokenType.Embed,
        embedUrl: url,
        accessToken: token
      };
      (window as any).powerbi.embed($container, reportLoadConfig);
    });
  }

  useEffect(() => {
    // console.log('powerbi.models.TokenType', powerbi.TokenType, powerbi.models.TokenType);
    getReportIndo();
  }, []);

  return (
    <div className='dtb-db-iframe-wrap' id='powerbi-container'></div>
  );
}
